<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableLoadBalancingResourceAzureListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableLoadBalancingResourceAzureVue = {};
export default {
  name: "TableLoadBalancingResourceAzure",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountName: "",
      name: "",
      resourceGroup: "",
      columns: [
        {
          title: this.$t("RAM.Azure.loadBalance.AccountName"),
          minWidth: 150,
          fixed: "left",
          key: "accountName"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.AccountID"),
          minWidth: 150,
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.SubscriptionID"),
          minWidth: 150,
          key: "subscriptionId"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.Name"),
          minWidth: 150,
          key: "name"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.ResourceGroup"),
          minWidth: 150,
          key: "resourceGroup"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.Area"),
          minWidth: 150,
          key: "region"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.BackendPool"),
          minWidth: 150,
          key: "backendAddressPools"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.HealthDetection"),
          minWidth: 150,
          key: "probes"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.LoadBalancingRules"),
          minWidth: 150,
          key: "loadBalancingRules"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.DedicatedIPAddress"),
          minWidth: 150,
          key: "privateIpAddress"
        },
        {
          title: this.$t("RAM.Azure.loadBalance.SKU"),
          minWidth: 150,
          fixed: "right",
          key: "sku"
        }
      ],
      tableLoadBalancingResourceAzureListData: []
    };
  },
  beforeCreate: function() {
    tableLoadBalancingResourceAzureVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("name", function(name) {
      tableLoadBalancingResourceAzureVue.name = name;
    });
    eventBus.$on("accountName", function(accountName) {
      tableLoadBalancingResourceAzureVue.accountName = accountName;
    });
    eventBus.$on("resourceGroup", function(resourceGroup) {
      tableLoadBalancingResourceAzureVue.resourceGroup = resourceGroup;
    });
    eventBus.$on("companyId", function(val) {
      tableLoadBalancingResourceAzureVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableLoadBalancingResourceAzureVue.getLoadBalancingResourceAzureListData();
    },
    // 分页显示数据
    /****************************************************/
    getLoadBalancingResourceAzureListData: function() {
      this.$api.resourceManagement
        .selectAzureLoadBalancerByPage({
          loadBalancerName: tableLoadBalancingResourceAzureVue.accountName,
          accountName: tableLoadBalancingResourceAzureVue.name,
          resourceGroup: tableLoadBalancingResourceAzureVue.resourceGroup,
          companyId: tableLoadBalancingResourceAzureVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableLoadBalancingResourceAzureListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableLoadBalancingResourceAzureVue.getLoadBalancingResourceAzureListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableLoadBalancingResourceAzureVue.getLoadBalancingResourceAzureListData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("name");
      eventBus.$off("accountName");
      eventBus.$off("resourceGroup");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/loadbalance/TableLoadBalancingResourceAzure.vue